import "./ServiceSubpages.module.css";
import Header from "@/reusable_sections/Header";
import AboutLinda from "./sections/AboutLinda";
import OurServices from "./sections/OurServices";
import BookAConsultation from "./sections/BookAConsultation";
import BeweiHandsTreatment from "./sections/BeweiHandsTreatment";
import Footer from "@/reusable_sections/Footer";
export default function ServiceSubpagesPage() {
  return <div>
      <Header />
      <AboutLinda />
      <BeweiHandsTreatment />
      <OurServices />
      <BookAConsultation />
      <Footer />
    </div>;
}